// extracted by mini-css-extract-plugin
export default {"logoLink":"HakoLogo_logoLink__sBj9W","logoLinkMobile":"HakoLogo_logoLinkMobile__SSP8c","logoImage":"HakoLogo_logoImage__e5rfo","logoImageMobile":"HakoLogo_logoImageMobile__KaBAl"};